export default __webpack_public_path__ + "static/media/CodeQuiz.432f8fbd.png";